import React, { useState } from "react";
import { Send, Loader2, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

const SERVICES = [
  "Website Design & Development",
  "SEO Optimization",
  "Digital Marketing",
  "API Integration",
  "Business Automation",
  "AI Website Builder",
  "Other",
];

export default function ContactForm() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", service: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Use the public lead endpoint (no auth required)
      await api.post("/leads", form);
      setSent(true);
      toast.success("Thanks! We'll reach out within 24 hours.");
      setForm({ name: "", email: "", phone: "", service: "", message: "" });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to send. Please try again.");
    } finally { setLoading(false); }
  };

  if (sent) {
    return (
      <div className="card p-8 text-center" data-testid="contact-form-success">
        <CheckCircle2 className="text-emerald-400 mx-auto mb-4" size={42}/>
        <h3 className="text-2xl font-bold text-white mb-2" style={{fontFamily:'Outfit'}}>Message Sent</h3>
        <p className="text-slate-400">Our team will contact you within 24 hours.</p>
        <button onClick={()=>setSent(false)} className="btn-ghost mt-5">Send another</button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="card p-7 sm:p-8 space-y-5" data-testid="contact-form">
      <div>
        <label className="label">Full Name *</label>
        <input required value={form.name} onChange={set("name")} placeholder="Enter your full name" className="input" data-testid="contact-name"/>
      </div>
      <div>
        <label className="label">Email Address *</label>
        <input type="email" required value={form.email} onChange={set("email")} placeholder="Enter your email" className="input" data-testid="contact-email"/>
      </div>
      <div>
        <label className="label">Phone Number *</label>
        <input required value={form.phone} onChange={set("phone")} placeholder="Enter your phone number" className="input" data-testid="contact-phone"/>
      </div>
      <div>
        <label className="label">Service Required *</label>
        <select required value={form.service} onChange={set("service")} className="input" data-testid="contact-service">
          <option value="">Select a service</option>
          {SERVICES.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
      <div>
        <label className="label">Message *</label>
        <textarea required rows={5} value={form.message} onChange={set("message")} placeholder="Tell us about your project" className="input" data-testid="contact-message"/>
      </div>
      <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="contact-submit">
        {loading ? <Loader2 size={16} className="animate-spin"/> : <><Send size={16}/> Send Message</>}
      </button>
    </form>
  );
}
